import styled from 'styled-components';

const Blockquote = styled.blockquote`
  padding: 0 32px;
  margin-top: 24px;
  font-style: italic;
  margin-bottom: 48px;
  color: var(--color-gray-700);

  @media ${(p) => p.theme.breakpoints.mdAndSmaller} {
    padding: 0 2rem;
  }

  @media ${(p) => p.theme.breakpoints.smAndSmaller} {
    padding: 0 1rem;
  }
`;

export default Blockquote;
